<template>
  <div class="h5-home">
    <div class="top-nav">
      <img class="nav-logo" src="@/assets/h5/logo.png" alt="准赞">
      <div class="nav-title">
        <div>遇见另一个有趣的你</div>
        <div>平行世界分身社交网络</div>
      </div>
      <button type="button" class="nav-open-btn" @click="onOpenClick">打开</button>
    </div>
    <section class="block block-1">
      <img class="block-img" src="@/assets/h5/block_01_img.png" alt="">
      <div class="block-content">
        <div class="block-1-content">
          <p class="main_title"><span>平行世界 乐趣无限</span></p>
          <p class="main_desc">连接另一个自己，探索平行世界的可能</p>
          <div class="download-actions">
            <a
              class="download-item"
              :href="IOS_DOWNLOAD_URL || 'javascript:void(0)'"
              target="_blank"
              rel="noopener"
              @click.prevent="onIosDownloadClick"
            >
              <img class="download-img" src="@/assets/pc/ios_btn.png" alt="">
            </a>
            <a
              class="download-item"
              href="https://www.zhunzan.cc/apk/zhunzan.apk"
              target="_blank"
              rel="noopener"
              @click.prevent="onDownloadClick"
            >
              <img class="download-img" src="@/assets/pc/android_btn.png" alt="">
            </a>
          </div>
          <p class="page-desc">准赞是基于AI大模型能力构建的数字分身平行世界社交网络，致力于为用户打造数字分身与真人的沉浸式社交体验，每个分身背后都有一个真实有趣的你。</p>
          <div class="h5-float-footer">
              <p>商务合作: zhunzan001@126.com</p>
              <div class="footer-links">
                  <a href="https://www.zhunzan.cc/h5/#/pages/mine/service" target="_blank">用户协议</a>
                  <a href="https://www.zhunzan.cc/h5/#/pages/mine/privacy" target="_blank">隐私协议</a>
                  <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2026013591号-1</a>
              </div>
          </div>
        </div>
      </div>
    </section>
    <section class="block block-2">
      <img class="block-img" src="@/assets/h5/block_02_img.png" alt="">
      <div class="block-content">
        <p class="block-title"><span>你眼前的 只是此刻</span></p>
        <p class="block-desc">其实另一个你，正在真实发生</p>
        <div class="download-actions">
          <a
            class="download-item"
            :href="IOS_DOWNLOAD_URL || 'javascript:void(0)'"
            target="_blank"
            rel="noopener"
            @click.prevent="onIosDownloadClick"
          >
            <img class="download-img" src="@/assets/pc/ios_btn.png" alt="">
          </a>
          <a
            class="download-item"
            href="https://www.zhunzan.cc/apk/zhunzan.apk"
            target="_blank"
            rel="noopener"
            @click.prevent="onDownloadClick"
          >
            <img class="download-img" src="@/assets/pc/android_btn.png" alt="">
          </a>
        </div>
      </div>
    </section>
    <section class="block block-3">
      <img class="block-img" src="@/assets/h5/block_03_img.png" alt="">
      <div class="block-content">
        <p class="block-title"><span>你还没出现 TA已经动心</span></p>
        <p class="block-desc">期待与你真实相遇</p>
        <div class="download-actions">
          <a
            class="download-item"
            :href="IOS_DOWNLOAD_URL || 'javascript:void(0)'"
            target="_blank"
            rel="noopener"
            @click.prevent="onIosDownloadClick"
          >
            <img class="download-img" src="@/assets/pc/ios_btn.png" alt="">
          </a>
          <a
            class="download-item"
            href="https://www.zhunzan.cc/apk/zhunzan.apk"
            target="_blank"
            rel="noopener"
            @click.prevent="onDownloadClick"
          >
            <img class="download-img" src="@/assets/pc/android_btn.png" alt="">
          </a>
        </div>
      </div>
    </section>
    <section class="block block-4">
      <img class="block-img" src="@/assets/h5/block_04_img.png" alt="">
      <div class="block-content">
        <p class="block-title"><span>虚拟互动 真实连接</span></p>
        <p class="block-desc">
          先遇见分身，再连接真实<br>
          每次互动都是通往TA的钥匙
        </p>
        <div class="download-actions">
          <a
            class="download-item"
            :href="IOS_DOWNLOAD_URL || 'javascript:void(0)'"
            target="_blank"
            rel="noopener"
            @click.prevent="onIosDownloadClick"
          >
            <img class="download-img" src="@/assets/pc/ios_btn.png" alt="">
          </a>
          <a
            class="download-item"
            href="https://www.zhunzan.cc/apk/zhunzan.apk"
            target="_blank"
            rel="noopener"
            @click.prevent="onDownloadClick"
          >
            <img class="download-img" src="@/assets/pc/android_btn.png" alt="">
          </a>
        </div>
      </div>
    </section>
    <div v-if="showWechatGuide" class="wechat-guide">
      <img class="wechat-guide-img" src="@/assets/h5/share_bg.png" alt="" @click="closeWechatGuide">
    </div>
  </div>
</template>

<script>

const ANDROID_DOWNLOAD_URL = 'https://www.zhunzan.cc/apk/zhunzan.apk'
const IOS_DOWNLOAD_URL = 'https://apps.apple.com/cn/app/%E5%87%86%E8%B5%9E-%E9%81%87%E8%A7%81%E5%8F%A6%E4%B8%80%E4%B8%AA%E6%9C%89%E8%B6%A3%E7%9A%84%E4%BD%A0/id6769264855'

export default {
  name: 'H5Home',
  data() {
    return {
      showWechatGuide: false,
      IOS_DOWNLOAD_URL,
    }
  },
  methods: {
    onOpenClick() {
      this.handleDownload(ANDROID_DOWNLOAD_URL)
    },
    onIosDownloadClick() {
      // if (!IOS_DOWNLOAD_URL) return
      this.handleDownload(IOS_DOWNLOAD_URL)
    },
    onDownloadClick() {
      this.handleDownload(ANDROID_DOWNLOAD_URL)
    },
    handleDownload(url) {
      const ua = navigator.userAgent || ''
      const isWechat = /MicroMessenger/i.test(ua)
      if (isWechat) {
        this.showWechatGuide = true
        return
      }
      window.location.href = url
    },
    closeWechatGuide() {
      this.showWechatGuide = false
    },
  },
}
</script>

<style scoped lang="scss">
$white: #fff;
$text: #111;
$title: #212121;
$purple: #871bdb;
$btn-gradient: linear-gradient(230deg, #fec212 0%, #e34bc1 30.54%, #871bdb 100%);
$title-gradient: linear-gradient(270deg, #fec212 0%, #e34bc1 31%, #871bdb 100%);

.h5-home {
  min-height: 100vh;
  background: $white;
  color: $text;

  .top-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    height: 1rem;
    background: $white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 0.42rem;
    padding-right: 0.32rem;
    box-sizing: border-box;
    gap: 0.19rem;
  }

  .nav-logo {
    width: 1.5rem;
    height: 0.63rem;
    object-fit: contain;
  }

  .nav-title {
    flex: 1;
    font-size: 0.24rem;
    color: $title;
    line-height: 0.34rem;
    text-align: left;
    white-space: pre-line;
  }

  .nav-open-btn {
    width: 0.96rem;
    height: 0.6rem;
    background: $btn-gradient;
    border-radius: 0.3rem;
    font-weight: 500;
    font-size: 0.24rem;
    color: #ffffff;
  }

  .block {
    width: 100%;
    position: relative;

    &.block-1 {
      height: 16.24rem;
    }

    &.block-2,
    &.block-3,
    &.block-4 {
      height: 14.3rem;
    }
  }

  .block-content {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
  }

  .block-1 .block-content {
    padding-bottom: 0.8rem;
  }

  .block-2 .block-content,
  .block-3 .block-content,
  .block-4 .block-content {
    padding-bottom: 1.46rem;
  }

  .block-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .main_title {
    font-weight: 600;
    font-size: 0.56rem;
    line-height: 0.78rem;
    text-align: center;

    > span {
      background: $title-gradient;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      -webkit-text-fill-color: transparent;
    }
  }

  .main_desc {
    font-size: 0.28rem;
    color: $purple;
    line-height: 0.39rem;
    text-align: center;
    margin-top: 4px;
  }

  .page-desc {
    width: 5.84rem;
    font-weight: 400;
    font-size: 0.24rem;
    color: $title;
    line-height: 0.34rem;
    text-align: center;
    margin: 0.67rem auto 0;
  }

  .block-title {
    font-weight: 600;
    font-size: 0.52rem;
    line-height: 0.73rem;
    text-align: center;

    > span {
      background: $title-gradient;
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      -webkit-text-fill-color: transparent;
    }
  }

  .block-desc {
    font-weight: 400;
    font-size: 0.28rem;
    color: #3d3d3d;
    line-height: 0.4rem;
    text-align: center;
    margin-top: 0.16rem;
  }

  .download-actions {
    display: flex;
    justify-content: center;
    gap: 0.24rem;
    margin-top: 0.44rem;
  }

  .download-img {
    width: 2.8rem;
    height: 0.72rem;
    object-fit: contain;
    display: block;
  }

  .wechat-guide {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
  }

  .wechat-guide-img {
    width: 7.5rem;
    max-width: 100%;
    height: auto;
    display: block;
  }

  .h5-float-footer .footer-links {
    display: flex;
    justify-content: center;
    gap: 0.1rem;
  }

  .h5-float-footer .footer-links a {
    color: #989898;
  }

  .h5-float-footer .footer-links a:nth-of-type(1),
  .h5-float-footer .footer-links a:nth-of-type(2) {
    text-decoration: underline;
  }

  .h5-float-footer .footer-links a:nth-of-type(3) {
    text-decoration: none;
  }

  .h5-float-footer {
    width: 100%;
    font-size: 0.2rem;
    color: #989898;
    line-height: 0.28rem;
    text-align: center;
    margin-top: 0.46rem;
  }
}
</style>
